// import request from '@/utils/request'
import axios from '@/http/api'
// let ishttps = 'https:' == document.location.protocol ? true: false;
// let httpData = ''
// if(ishttps){
//   httpData = 'https://'
// }else {
//   httpData = 'http://'
// }
//3.2.3 增加、更新 个人云盘目录
export const insertOrUpdatePriOneDir = data => {
  return axios({
    url: '/consoleGateway/diskDirFileController/insertOrUpdatePriOneDir',
    method: 'post',
    data
  })
}
//3.2.4 增加、更新 公共云盘目录
export const insertOrUpdatePubOneDir = data => {
  return axios({
    url: '/consoleGateway/diskDirFileController/insertOrUpdatePubOneDir',
    method: 'post',
    data
  })
}


//3.2.15 修改目录名称
export const updateDirNameInfo = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/updateDirNameInfo',
    method: 'post',
    data
  })
}




//3.2.16 修改文件名称
export const updateFileNameInfo = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/updateFileNameInfo',
    method: 'post',
    data
  })
}
//3.2.5 删除个人云盘目录
export const deletePriBatchDir = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/deletePriBatchDir',
    method: 'post',
    data
  })
}
//3.2.6 删除公共云盘目录
export const deletePubBatchDir = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/deletePubBatchDir',
    method: 'post',
    data
  })
}

//3.2.13 删除个人云盘文件
export const deletePriBatchFile = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/deletePriBatchFile',
    method: 'post',
    data
  })
}
//3.2.14 删除公共云盘文件
export const deletePubBatchFile = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/deletePubBatchFile',
    method: 'post',
    data
  })
}




//3.2.20 文件上传前验证（综合3.2.17：目前先校验文件大小，Md5）
export  const selectPreUploadCheck = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/selectPreUploadCheck',
    method: 'post',
    data
  })
}

//3.2.10 模糊搜索关键字 所有的文件信息（只有文件，无目录信息）
export  const selectDirFileByKeyWord = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/selectDirFileByKeyWord',
    method: 'post',
    data
  })
}
//3.2.6 批量下载文件
export  const downloadMultiFile = (data,addrWeb) => {
  return axios({
    // url: '/privateCloud/'+ addrWeb +'/IQMediaLibService/fileLoadController/downloadMultiFile',
    url:  '/IQMediaLibService/fileLoadController/downloadMultiFile',
    method: 'post',
    baseURL:addrWeb,
    data
  })
}

export  const selectSystemCloudId = data => {
  return axios({
    url:'/consoleGateway/userInfoController/selectSystemCloudId',
    method: 'post',
    data
  })
}



//
//3.2.17 移动文件到指定目录下
export  const updateFileDirInfo = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/updateFileDirInfo',
    method: 'post',
    data
  })
}

//3.2.4 分块全部上传后，拼接。
export  const mergerBlockFile =  (data,addrWeb) => {
  return axios({
    // url:  '/privateCloud/'+ addrWeb +'/IQMediaLibService/fileLoadController/mergerBlockFile',
    url: '/IQMediaLibService/fileLoadController/mergerBlockFile',
    method: 'post',
    baseURL:addrWeb,
    data
  })
}

//3.2.11 个人云盘上传文件成功后入库（增加文件）
export  const insertPriOneFile = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/insertOrUpdatePriOneFile',
    method: 'post',
    data
  })
}

//3.2.12 公共云盘上传文件成功后入库（增加文件）
export  const insertPubOneFile = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/insertOrUpdatePubOneFile',
    method: 'post',
    data
  })
}


//3.3.4 获取用户浏览、下载等日志
export  const selectUserDownloadLog = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/selectUserDownloadLog',
    method: 'post',
    data
  })
}

//3.2.16 移动目录到指定的目录下
export  const updateDirPDirInfo = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/updateDirPDirInfo',
    method: 'post',
    data
  })
}

//3.3.5 删除获取用户浏览、下载等日志
export  const deleteDownloadInfo = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/deleteDownloadInfo',
    method: 'post',
    data
  })
}

//3.3.2 增加文件下载、浏览、收藏等记录
export  const insertFileVisitLog = data => {
  return axios({
    url:'/consoleGateway/diskDirFileController/insertFileVisitLog',
    method: 'post',
    data
  })
}

//3.3.3 获取用户具有的功能权限
export  const selectUserBindRoleByUserId = data => {
  return axios({
    url:'/consoleGateway/roleController/selectUserBindRoleByUserId',
    method: 'post',
    data
  })
}


//3.1.7查询当前用户的空间一些信息（总大小、已用大小等）
export  const selectUserSpaceInfo = data => {
  return axios({
    url:'/consoleGateway/diskSpaceManageController/selectUserSpaceInfo',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/resources.js